"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgHeadset = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M11 4a5 5 0 00-5 5 2 2 0 012 2v4a2 2 0 01-4 0V9a7 7 0 017-7h2a7 7 0 017 7v6.5a1.5 1.5 0 01-1.5 1.5v3a1 1 0 01-1 1H15a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a1 1 0 011-1h3a1 1 0 011 1h2.5v-3a1.5 1.5 0 01-1.5-1.5V11a2 2 0 012-2 5 5 0 00-5-5h-2z' }))); };
exports.default = SvgHeadset;
//# sourceMappingURL=Headset.js.map